if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.variantChangeUnsubscriber = undefined;
      }

      connectedCallback() {
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        if (!this.elements.viewer) return;
        if (this.bound) return;
        this.bound = true;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            const btn = mediaToSwitch.querySelector('button');
            if (btn) btn.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });
        }
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        const sectionEl = this.closest('[data-section]');
        const sectionId = this.dataset.section || sectionEl?.dataset?.section;
        this._lastVariantId = null;
        this.switchGalleryByVariant = (variantId) => {
          if (!variantId) return;
          let vid = String(variantId);
          if (this._lastVariantId === vid) return;
          const viewerList = this.elements.viewer.querySelector('.product__media-list.variant-media-gallery');
          if (!viewerList) return;
          const thumbList = this.elements.thumbnails?.querySelector('.thumbnail-list.variant-media-gallery');
          const hasSlidesForVariant = viewerList.querySelector(`[data-variant-id="${vid}"]`);
          if (!hasSlidesForVariant) {
            const first = viewerList.querySelector('[data-variant-id]');
            vid = first?.dataset?.variantId || vid;
          }
          this._lastVariantId = vid;
          viewerList.querySelectorAll('[data-variant-id]').forEach((el) => {
            el.classList.toggle('variant-hidden', el.dataset.variantId !== vid);
          });
          if (thumbList) {
            thumbList.querySelectorAll('[data-variant-id]').forEach((el) => {
              el.classList.toggle('variant-hidden', el.dataset.variantId !== vid);
            });
          }
          const firstSlide = viewerList.querySelector(`[data-variant-id="${vid}"][data-media-id]`);
          if (firstSlide && firstSlide.dataset.mediaId) {
            viewerList.querySelectorAll('.product__media-item').forEach((el) => el.classList.remove('is-active'));
            firstSlide.classList.add('is-active');
            this.elements.viewer.resetPages?.();
            if (this.elements.thumbnails) this.elements.thumbnails.resetPages?.();
            this.setActiveMedia(firstSlide.dataset.mediaId, true);
          }
        };
        if (sectionId) {
          const variantInput = document.querySelector(`#product-form-${sectionId} input[name="id"]`) || sectionEl?.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.addEventListener('change', () => this.switchGalleryByVariant(variantInput.value));
            this.switchGalleryByVariant(variantInput.value);
          }
          if (typeof subscribe === 'function') {
            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              if (!event || !event.data || event.data.sectionId !== sectionId || !event.data.variant || !event.data.variant.id) return;
              this.switchGalleryByVariant(event.data.variant.id);
            });
          }
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      onSlideChanged(event) {
        const currentEl = event.detail?.currentElement;
        if (!currentEl || !currentEl.dataset.mediaId) return;

        this.playActiveMedia(currentEl);

        const thumbList = this.getVisibleThumbnailList();
        if (!thumbList) return;

        const isVariantMedia = thumbList.classList.contains('variant-media-gallery');
        const sel = isVariantMedia ? `[data-target="${currentEl.dataset.mediaId}"]:not(.variant-hidden)` : `[data-target="${currentEl.dataset.mediaId}"]`;
        const thumbnail = thumbList.querySelector(sel);
        if (!thumbnail) return;

        this.setActiveThumbnail(thumbnail);
      }

      getVisibleThumbnailList() {
        if (!this.elements.thumbnails) return null;
        return this.elements.thumbnails.querySelector('.thumbnail-list.variant-media-gallery') ||
          this.elements.thumbnails.querySelector('.thumbnail-list');
      }

      getVisibleViewerList() {
        if (!this.elements.viewer) return null;
        return this.elements.viewer.querySelector('.product__media-list.variant-media-gallery') ||
          this.elements.viewer.querySelector('.product__media-list');
      }

      setActiveMedia(mediaId, prepend) {
        const viewerList = this.getVisibleViewerList();
        const viewContainer = viewerList || this.elements.viewer;
        if (!viewContainer) return;

        const isVariantMedia = viewerList && viewerList.classList.contains('variant-media-gallery');
        const sel = isVariantMedia ? `[data-media-id="${mediaId}"]:not(.variant-hidden)` : `[data-media-id="${mediaId}"]`;
        const activeMedia = viewContainer.querySelector(sel);
        if (!activeMedia) return;

        viewContainer.querySelectorAll('[data-media-id]:not(.variant-hidden)').forEach((el) => el.classList.remove('is-active'));
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          const thumbList = this.getVisibleThumbnailList();
          if (thumbList && this.elements.thumbnails) {
            const thumbSel = isVariantMedia ? `[data-target="${mediaId}"]:not(.variant-hidden)` : `[data-target="${mediaId}"]`;
            const activeThumbnail = thumbList.querySelector(thumbSel);
            if (activeThumbnail) activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer && this.elements.viewer.resetPages) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            if (activeMedia.parentElement) activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const thumbList = this.getVisibleThumbnailList();
        if (!thumbList) return;
        const thumbSel = isVariantMedia ? `[data-target="${mediaId}"]:not(.variant-hidden)` : `[data-target="${mediaId}"]`;
        const activeThumbnail = thumbList.querySelector(thumbSel);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail?.dataset?.mediaPosition) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!thumbnail) return;

        const thumbList = this.getVisibleThumbnailList();
        const container = thumbList || this.elements.thumbnails;
        if (!container) return;

        container.querySelectorAll('button').forEach((el) => el.removeAttribute('aria-current'));
        const btn = thumbnail.querySelector('button');
        if (btn) btn.setAttribute('aria-current', true);

        const slider = this.elements.thumbnails?.slider;
        if (!slider) return;
        if (this.elements.thumbnails.isSlideVisible && this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem?.querySelector('.product__modal-opener--image img');
        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (!deferredMedia) return;

        deferredMedia.loadContent(false);
        const video = deferredMedia.querySelector('video');
        if (!video || !deferredMedia.getAttribute('loaded')) return;
        video.play().catch(() => {});
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        const viewer = this.elements.viewer;
        if (!viewer || !viewer.slider) return;

        viewer.slider.setAttribute('role', 'presentation');
        viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
